













































































import { AccountInDefaultModalVue } from "fs-pb-vue2/vueModels/settings/AccountInDefaultModalVue";
import { Component } from "vue-property-decorator";
import VerifyBox from "@/components/app/VerifyBox.vue";

@Component({
  components: { VerifyBox }
})
export default class AccountInDefaultModal extends AccountInDefaultModalVue {
  async mounted() {
    await this.init();
  }
}
